import React, { Component } from 'react';

import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AddAwardContainer from '../Components/AddNew/AddAwardContainer';
import Course from '../Components/Master/Collaborations/Course';

class AddCollaborationNewContainerMain extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));
        
        
        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
        
    }
    
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">
               
                            <Course
                                
                                history={this.props.history}
                                title="Collaborations"
                                code="collaborations"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />
                    

                   

                </div>
            </div>
        )
    }
}

export default withAuth(AddCollaborationNewContainerMain);



// WEBPACK FOOTER //
// ./src/Containers/AddCollaborationNewContainerMain.js